import { useEffect, useState,useMemo } from 'react';
import { useParams } from 'react-router';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, FormControlLabel, Checkbox, FormControl, CircularProgress, InputAdornment, Box, FormGroup, Typography, Tooltip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { checkApiStatus, numberWithCommas, formatCycles } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { addLeaseApi, editLeaseApi } from '../apiServices';
import { assetTypeId, backendDateFormat, fieldDateFormat } from '../../../constants';
import AttachementsUpload from '../../../shared_elements/components/AttachementsUpload';
import { cleanPayload } from '../../../utils/helper';
import { assetTypeMap } from './LeaseConstants';
import { regexConstants } from '../../../constants/regEx';
import { getAssetListApi, getConstantTypesApi, getLesseeApi, getOwnerLessorApi, getOwnerListApi, getStorage } from '../../../shared_elements/actionCreators';
import { globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { trackActivity } from '../../../utils/mixpanel';
import { formatBytes } from '../../../utils/fileUpload';
import { ButtonLoader } from '../../../shared_elements/components';
import InfoIcon from '@mui/icons-material/Info';
import { gaTelesisInstance } from '../../../shared_elements';

const LeaseCRU = ({ fileUpload, addEditLeases, moduleName, getResponseBack, onToggleModal, onOpenAttachments, modeType }) => {
  const params = useParams();
  const dispatch = useDispatch()
  const { assetList, constantTypes, lessee, owner, storageDetails } = useSelector((state) => state.leases);  
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [lessorDropdown, setLessorDropdown] = useState(owner || []);
  const [isDropDownLoading, setIsDropDownLoading] = useState({ assetList: !(assetList?.length > 0), constantTypes: !(constantTypes?.length > 0), lessee: !(lessee?.length > 0), owner: !(owner?.length > 0), lessor: !(lessorDropdown?.length > 0), storage: false });
  const [data, setData] = useState({ ...addEditLeases?.data, asset_id: addEditLeases?.data?.asset, lessee_id: addEditLeases?.data?.lessee, operator_id: addEditLeases?.data?.operator, lessor_detail: addEditLeases?.data?.lessor_detail, owner_id: addEditLeases?.data?.owner });
  const [error, setError] = useState({});
  const [attachments, setAttachments] = useState([]);
  const leaseDurationTypeValue = typeof data?.lease_duration_type === 'object' ? data?.lease_duration_type?.value : data?.lease_duration_type;
  const totalStorage=2684354560;
  // Asset can be changed only while the lease is still in Draft status
  const isAssetLocked = Boolean(addEditLeases?.data?.id) && addEditLeases?.data?.status !== "Draft";
  const assetValue = useMemo(() => {
    if (moduleName === "leaseInfo") {
      return assetList?.find(
        (item) =>
          item.slug === params?.asset_slug &&
          item.asset_type === assetTypeId[params?.asset_type]
      ) ?? null;
    }
    return (
      assetList?.find(
        (opt) => Number(opt?.id) === data?.asset_id?.id
      ) ?? data?.asset_id ?? null
    );
  }, [assetList, moduleName, params, data]);
  useEffect(() => {
    const payload = {
      constant_types: ["lease_duration_type", "lease_type"]
    };
    if (!assetList?.length) {
      dispatch(getAssetListApi({ setIsDropDownLoading }));
    }
    if (!lessee?.length) {
      dispatch(getLesseeApi({ setIsDropDownLoading }));
    }
    if (!owner?.length) {
      dispatch(getOwnerListApi({ setIsDropDownLoading }));
    }
    if (data?.id && data?.slug) {
      dispatch(getStorage({ lease_slug: data?.slug, module_name: "lease", setIsDropDownLoading }))
    }
    dispatch(getConstantTypesApi(payload, { setIsDropDownLoading }));
  }, [dispatch]);

  useEffect(() => {
    if (owner && owner.length > 0) {
      setLessorDropdown(owner);
      setIsDropDownLoading(prev => ({
        ...prev,
        lessor: false
      }));
    }
  }, [owner]);

  const onRestErrorKey = (keyParam) => {
    setError({ ...error, [keyParam]: '' })
  }

  const onFieldChange = (key, value) => {
    const updatedData = { ...data };
    const updatedError = { ...error };
    if (key === "same_operator_lessee") {
      updatedData.same_operator_lessee = value ? Number(value.id) : null;
      updatedData.operator_id = updatedData.same_operator_lessee === 1 ? data.lessee_id : "";
      updatedError.same_operator_lessee = "";
    } else if (key === "start_date") {
      updatedData.start_date = value;
      updatedData.contractual_start_date = value;
      updatedError.start_date = "";
      updatedError.contractual_start_date = "";
    } else if (key === "lease_duration") {
      if (regexConstants?.numberWithDot.test(value)) {
        updatedData.lease_duration = value;
        updatedError.lease_duration = "";
      }
    } else if (key === "time_between_interval") {
      if (value === "" || regexConstants?.isValidNumeric.test(value)) {
        updatedData.time_between_interval = value;
        updatedError.time_between_interval = "";
      }
    } else if (key === "lessor_detail") {
      updatedData.lessor_detail = value;
      updatedError.lessor_detail = "";
    } else if (key === "owner_id") {
      updatedData.owner_id = value;
      updatedData.owner = value;
      updatedError.owner_id = "";
    } else if (key === "lessee_id") {
      updatedData.lessee_id = value;
      updatedData.lessee = value;
      updatedError.lessee_id = "";
    } else if (key === "asset_id") {
      updatedData.asset_id = value;
      updatedData.asset = value;
      updatedError.asset_id = "";
    } else if (key === "lease_duration_type") {
      updatedData[key] = value;
      updatedError[key] = "";
      updatedError.planned_utilization_fh = "";
      updatedError.planned_utilization_fc = "";
    } else {
      updatedData[key] = value;
      updatedError[key] = "";
    }
    setData(updatedData);
    setError(updatedError);
  };

  const handleFileChange = (files) => {
    setAttachments(files);
    dispatch(setFileUploadDetails({ attachments: files }))
  };
  const onAddEditLease = () => {
    let validationInputs = {
      asset_id: data?.asset || data?.asset_id || assetValue ? "" : "Please select Asset",
      lessor_detail: data?.lessor_detail ? "" : "Please select Lessor",
      lease_type: data?.lease_type ? "" : "Please select Lease Type",
      lessee_id: data?.lessee_id || data?.lessee ? "" : "Please select Lessee",
      same_operator_lessee: typeof data.same_operator_lessee === 'number' ? "" : "Please select Operator Same as Lessee",
      operator_id: data?.same_operator_lessee === 1 ? "" : !data?.operator_id?.id && typeof data?.operator_id !== "number" ? "Please select Operator" : (data?.lessee_id === data?.operator_id?.id || data?.lessee?.id === data?.operator_id?.id || data?.lessee_id === data?.operator_id) ? "Operator can't be same as Lessee" : "",
      // owner_id: data?.owner || data?.owner_id ? "" : "Please select Owner",
      lease_duration_type: data?.lease_duration_type ? "" : "Please select Lease Duration Type",
      contractual_start_date: !data?.contractual_start_date ? `Please select a valid ${gaTelesisInstance ? "Lease Signature Date" : "Contract Start Date"}` : "",
      start_date: data?.start_date ? "" : "Please select a valid Start Date",
      end_date: ![3, 5].includes(leaseDurationTypeValue) ? data?.end_date ? "" : "Please select a valid End Date":"",
      lease_duration: leaseDurationTypeValue && leaseDurationTypeValue !== 1 ? data?.lease_duration ? "" : "Please enter Lease Duration" : "",
      // time_between_interval: [3, 5].includes(leaseDurationTypeValue) ? data?.time_between_interval ? "" : "Please enter Time Between Interval" : "",
      // planned_utilization_fh: leaseDurationTypeValue === 3 ? data?.planned_utilization_fh ? "" : "Please enter Planned Utilization(FH)" : "",
      // planned_utilization_fc: leaseDurationTypeValue === 5 ? data?.planned_utilization_fc ? "" : "Please enter Planned Utilization(FC)" : "",
      planned_utilization_fh: leaseDurationTypeValue === 3 ? (!data?.planned_utilization_fh ? "Please enter Planned Utilization(FH)" : parseFloat(data?.planned_utilization_fh) <= 0 ? "Planned Utilization(FH) should be greater than 0" : "") : "",
      planned_utilization_fc: leaseDurationTypeValue === 5 ? (!data?.planned_utilization_fc ? "Please enter Planned Utilization(FC)" : parseFloat(data?.planned_utilization_fc) <= 0 ? "Planned Utilization(FC) should be greater than 0" : "") : "",
    };
    const startDate = moment(data?.start_date);
    const endDate = moment(data?.end_date);
    const contractStartDate=moment(data?.contractual_start_date);
    if (data?.start_date && data?.end_date) {
      if (startDate.isAfter(endDate))  validationInputs['start_date'] = "Start Date cannot be after End Date";
      if (endDate.isBefore(startDate))  validationInputs['end_date'] = "End Date cannot be before Start Date";
    }
    if(data?.start_date && data?.end_date && data?.contractual_start_date){
      if(contractStartDate.isAfter(startDate)) validationInputs['contractual_start_date']=`${gaTelesisInstance ? "Lease Signature Date" : "Contract Start Date"} cannot be after Lease Start Date`;
    }
    const selectedAsset = moduleName === "leaseInfo" ? (data?.asset ?? assetValue) : data?.asset_id;
    const rawAssetType = selectedAsset?.asset_type ?? data?.asset_type ?? params?.asset_type;
    const rawAssetTypeString = typeof rawAssetType === "string" ? rawAssetType.trim().toLowerCase() : rawAssetType;
    const assetTypeLookup = { lg: "landing_gear" };
    const normalizedAssetTypeString = assetTypeLookup[rawAssetTypeString] || rawAssetTypeString;
    const selectedAssetTypeId = Number(rawAssetType) || Number(Object.entries(assetTypeMap).find(([, value]) => value === normalizedAssetTypeString)?.[0]) || Number(Object.entries(assetTypeMap).find(([, value]) => value === rawAssetTypeString)?.[0]);
    const selectedAssetTypeForApi = assetTypeMap[selectedAssetTypeId] || normalizedAssetTypeString || rawAssetTypeString;
    const selectedAssetSlug = selectedAsset?.asset_slug ?? selectedAsset?.slug ?? data?.asset_slug ?? params?.asset_slug;
    if (!Number.isFinite(selectedAssetTypeId)) {
      validationInputs.asset_id = "Please select a valid Asset";
    }


    const payload = cleanPayload({
      ...data,
      assigned_code: data?.assigned_code ? data?.assigned_code : "",
      operator_id: data?.operator_id?.id,
      asset_id: moduleName === "leaseInfo" ? (data?.asset?.id || assetValue?.id) : data?.asset_id?.id,
      asset_type: selectedAssetTypeId,
      asset_slug: selectedAssetSlug,
      lessee_id: data?.lessee_id?.id,
      lease_type: data?.lease_type?.value,
      owner_id: data?.owner_id?.id,
      lessor_id: null,
      lessor_detail: data?.lessor_detail,
      lease_duration_type: data?.lease_duration_type?.value ? data?.lease_duration_type?.value : data?.lease_duration_type,
      lessor_jurisdiction: data?.lessor_detail?.jurisdiction || null,
      contact_address: data?.lessor_detail?.contact_address || null,
      lessor_contact_email: data?.lessor_detail?.contact_email || null,
      lessor_phone_number: data?.lessor_detail?.contact_phone_number || null,
      lessor_contact_fax_number: data?.lessor_detail?.contact_fax || null,
      lessor_country_of_incorporation: data?.lessor_detail?.lessor_country_of_incorporation || null,
      lessee_contact_email: data?.lessee?.contact_email || null,
      lessee_phone_number: data?.lessee?.contact_phone_number || null,
      lessee_contact_fax_number: data?.lessee?.contact_fax_number || null,
      attention_to: data?.lessee?.atten_to || null,
      lessee_contact_address: data?.lessee?.contact_address || null,
      lessee_country_of_incorporation: data?.lessee?.country_of_incorporation || null,
      lessee_name: data?.lessee?.name || null
    })
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true);
      if (data.id) {
        globalPutService(editLeaseApi({
          asset_slug: selectedAssetSlug,
          asset_type: selectedAssetTypeForApi,
          lessor_detail: data?.lessor_detail,
          slug: data?.slug,
        }), payload).then(async (response) => {
          if (checkApiStatus(response)) {
            if (attachments?.length) {
              fileUpload(data?.slug,'updated')
            }
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
            onToggleModal()
            getResponseBack();
            setLoading(false);
            trackActivity('Item Edited', { page_title: `Edit Lease`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
          } else {
            setLoading(false);
            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
            trackActivity('Item Edited', { page_title: `Edit Lease`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
          }
        });
      } else {
        globalPostService(
          addLeaseApi({ asset_type: selectedAssetTypeForApi, asset_slug: selectedAssetSlug, }), { ...payload, status: "Draft", })
          .then(async (response) => {
            if (checkApiStatus(response)) {
              if (attachments?.length) {
                fileUpload(response?.data?.data?.slug,'created')
              }
              enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              onToggleModal()
              getResponseBack();
              setLoading(false);
              trackActivity('Item Added', { page_title: `Add Lease`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
            } else {
              setLoading(false);
              enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
              trackActivity('Item Added', { page_title: `Add Lease`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
            }
          });

      }
    } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${data?.id ? `${addEditLeases.mode === "view" ? "View" : "Edit"} Lease` : "Add Lease"}`, error_msg: validationInputs, })
    }
  };
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `${data?.id ? `${addEditLeases.mode === "view" ? "View" : "Edit"} Lease` : "Add Lease"}`, page_type: page_type, })
  }
  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        className='add-lease-dialog'
        maxWidth='md'
        fullWidth
        open={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
          <Typography sx={{ marginLeft: '10px' }}>
            {data?.id ? `${addEditLeases.mode === "view" ? "View" : "Edit"} Lease` : "Add Lease"}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={assetList || []}
                getOptionLabel={(option) => option?.name || ""}
                noOptionsText={isDropDownLoading?.assetList ? "Loading..." : "No Option Available"}
                disabled={modeType === "view" || moduleName === "leaseInfo" || isAssetLocked}
                value={assetValue}
                onChange={(e, value) => { onFieldChange("asset_id", value); }}
                onFocus={() => onRestErrorKey("asset_id")}
                renderOption={(props, option) => {
                  const lessor = option?.lessor || "";
                  const isLongLessor = lessor.length > 23;
                  const displayLessor = isLongLessor ? `${lessor.slice(0, 20)}...` : lessor;

                  return (
                    <Box component="li" {...props} key={option.slug} sx={{ display: "block", py: 1, }} >
                      <Box sx={{ fontSize: "14px" }}> {option.name} </Box>

                      {lessor ? (
                        <Tooltip title={isLongLessor ? lessor : ""} arrow placement="right" >
                          <Box component="span" sx={{ display: "block", fontSize: "12px", color: "rgba(0,0,0,0.6)", ml: 1, mt: 0.25, lineHeight: 1.4, cursor: isLongLessor ? "pointer" : "default", }} > ({displayLessor}) </Box>
                        </Tooltip>
                      ) : null}
                    </Box>
                  );
                }}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                    <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                      <TextField
                        {...params}
                        label="Asset"
                        margin="normal"
                        size="small"
                        required
                        error={Boolean(error.asset_id)}
                        helperText={error.asset_id}
                        disabled={modeType === "view"}
                        slotProps={{
                          inputLabel: { shrink: true, },
                          input: { ...params?.InputProps,
                            endAdornment: (
                              <>
                                {isDropDownLoading?.assetList ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params?.InputProps?.endAdornment}
                              </>
                            ),
                          },
                        }}
                      />
                    </Tooltip>
                  );
                }}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={constantTypes?.filter((opt) => opt?.type === "lease_type") || []}
                getOptionLabel={(option) => option?.label || ""}
                noOptionsText={isDropDownLoading?.constantTypes ? "Loading..." : "No Option Available"}
                disabled={modeType === 'view'}
                value={data?.lease_type || null}
                onChange={(e, value) => { onFieldChange("lease_type", value) }}
                onFocus={() => onRestErrorKey("lease_type")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    {...params}
                    label="Lease Type"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error.lease_type)}
                    helperText={error.lease_type}
                    disabled={modeType === 'view'}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.constantTypes ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <TextField
                id="assigned_code"
                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("assigned_code", e.target.value.trimStart()) : e.preventDefault() }}
                value={data?.assigned_code}
                error={data?.assigned_code?.length > 50}
                helperText={data?.assigned_code?.length > 50 ? "Maximum 50 characters allowed" : ""}
                label="Assigned Code"
                variant="outlined"
                size="small"
                margin="normal"
                fullWidth
                slotProps={{ inputLabel: { shrink: true }, input: { maxLength: 50 } }}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={lessee || []}
                getOptionLabel={(option) => option?.name || ""}
                noOptionsText={isDropDownLoading?.lessee ? "Loading..." : "No Option Available"}
                disabled={modeType === 'view'}
                value={lessee?.find((opt) => Number(opt?.id) === data?.lessee_id?.id) || data?.lessee_id || null}
                onChange={(e, value) => { onFieldChange("lessee_id", value) }}
                onFocus={() => onRestErrorKey("lessee_id")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    {...params}
                    label="Lessee"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error.lessee_id)}
                    helperText={error.lessee_id}
                    disabled={modeType === 'view'}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.lessee ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}/>
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={[{ id: "1", label: "Yes" }, { id: "0", label: "No" }]}
                getOptionLabel={(option) => option?.label || ""}
                disabled={modeType === 'view'}
                value={[{ id: "1", label: "Yes" }, { id: "0", label: "No" }].find((option) => option.id === String(data.same_operator_lessee)) || data.same_operator_lessee}
                onChange={(e, value) => { onFieldChange("same_operator_lessee", value) }}
                onFocus={() => onRestErrorKey("same_operator_lessee")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    {...params}
                    label="Operator Same as Lessee"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error.same_operator_lessee)}
                    helperText={error.same_operator_lessee}
                    slotProps={{ inputLabel: { shrink: true } }}
                    disabled={modeType === 'view'}
                  />
                </Tooltip>)}}
              />
            </Grid>
            {data.same_operator_lessee === 0 && (
              <Grid size={{ md: 4, xs: 12 }}>
                <Autocomplete
                  disablePortal
                  disableClearable
                  options={lessee || []}
                  getOptionLabel={(option) => option?.name || ""}
                  noOptionsText={isDropDownLoading?.lessee ? "Loading..." : "No Option Available"}
                  disabled={modeType === 'view'}
                  value={lessee?.find((opt) => Number(opt?.id) === data?.operator_id?.id) || data?.operator_id || null}
                  onChange={(e, value) => { onFieldChange("operator_id", value) }}
                  onFocus={() => onRestErrorKey("operator_id")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Operator"
                      margin='normal'
                      size='small'
                      required
                      error={Boolean(error.operator_id)}
                      helperText={error.operator_id}
                      disabled={modeType === 'view'}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                        input: {
                          ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.lessee ? (<CircularProgress color="inherit" size={20} />) : null}
                            {params?.InputProps?.endAdornment}
                          </>
                          )
                        }
                      }}
                    />
                  )}
                />
              </Grid>
            )}
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={constantTypes?.filter((opt) => opt?.type === "lease_duration_type") || []}
                getOptionLabel={(option) => option?.label || ""}
                noOptionsText={isDropDownLoading?.constantTypes ? "Loading..." : "No Option Available"}
                disabled={modeType === 'view'}
                value={constantTypes?.find((opt) => opt?.value === data?.lease_duration_type && opt?.type === "lease_duration_type") || data?.lease_duration_type}
                onChange={(e, value) => { onFieldChange("lease_duration_type", value) }}
                onFocus={() => onRestErrorKey("lease_duration_type")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    {...params}
                    label="Lease Duration Type"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error.lease_duration_type)}
                    helperText={error.lease_duration_type}
                    disabled={modeType === 'view'}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.constantTypes ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                disableClearable
                options={lessorDropdown || []}
                getOptionLabel={(option) => option?.name || ""}
                noOptionsText={isDropDownLoading?.lessor ? "Loading..." : "No Option Available"}
                disabled={modeType === 'view'}
                value={data?.lessor_detail || null}
                onChange={(e, value) => { onFieldChange("lessor_detail", value) }}
                onFocus={() => onRestErrorKey("lessor_detail")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    {...params}
                    label="Lessor/Holdco"
                    margin='normal'
                    size='small'
                    required
                    error={Boolean(error.lessor_detail)}
                    helperText={error.lessor_detail}
                    disabled={modeType === 'view'}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.lessor ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <Autocomplete
                disablePortal
                options={owner || []}
                getOptionLabel={(option) => option?.name || ""}
                noOptionsText={isDropDownLoading?.owner ? "Loading..." : "No Option Available"}
                disabled={modeType === 'view'}
                value={owner?.find((opt) => Number(opt?.id) === data?.owner_id?.id) || data?.owner_id || null}
                onChange={(e, value) => { onFieldChange("owner_id", value) }}
                onFocus={() => onRestErrorKey("owner_id")}
                renderInput={(params) => {
                  const selectedLabel = params?.inputProps?.value || "";
                  return (
                  <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                  <TextField
                    {...params}
                    label="Owner/SPV"
                    margin='normal'
                    size='small'
                    error={Boolean(error.owner_id)}
                    helperText={error.owner_id}
                    disabled={modeType === 'view'}
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                      input: {
                        ...params?.InputProps, endAdornment: (<>{isDropDownLoading?.owner ? (<CircularProgress color="inherit" size={20} />) : null}
                          {params?.InputProps?.endAdornment}
                        </>
                        )
                      }
                    }}
                  />
                </Tooltip>)}}
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="Start Date"
                  value={data?.start_date ? moment(data.start_date) : null}
                  onChange={(data) => {
                    const isValid = moment(data)?.isValid();
                    const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                    onFieldChange("start_date", formattedDate);
                    if (isValid) {
                      onRestErrorKey("start_date");
                    }
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      error: error.start_date || false,
                      helperText: error.start_date || '',
                      onFocus: () => {
                        if (error.start_date) {
                          onRestErrorKey("start_date");
                        }
                      }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("start_date", null);
                        onRestErrorKey("start_date");
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  disabled={modeType === 'view'}
                />
              </LocalizationProvider>
            </Grid>
            {![3, 5].includes(leaseDurationTypeValue) &&
            <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="End Date"
                  value={data?.end_date ? moment(data.end_date) : null}
                  minDate={data?.start_date ? moment(data.start_date) : null}
                  onChange={(data) => {
                    const isValid = moment(data)?.isValid();
                    const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                    onFieldChange("end_date", formattedDate);
                    if (isValid) {
                      onRestErrorKey("end_date");
                    }
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      error: error.end_date || false,
                      helperText: error.end_date || '',
                      onFocus: () => {
                        if (error.end_date) {
                          onRestErrorKey("end_date");
                        }
                      }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("end_date", null);
                        onRestErrorKey("end_date");
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  disabled={modeType === 'view'}
                />
              </LocalizationProvider>
            </Grid>}
             <Grid size={{ md: 4, xs: 12 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label={gaTelesisInstance ? "Lease Signature Date" : "Contract Date"}
                  value={data?.contractual_start_date ? moment(data.contractual_start_date) : null}
                  onChange={(data) => {
                    const isValid = moment(data)?.isValid();
                    const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                    onFieldChange("contractual_start_date", formattedDate);
                    if (isValid) {
                      onRestErrorKey("contractual_start_date");
                    }
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                      InputLabelProps: { shrink: true },
                      size: "small",
                      margin: "normal",
                      error: Boolean(error.contractual_start_date),
                      helperText: error.contractual_start_date,
                      onFocus: () => {
                        if (error.contractual_start_date) {
                          onRestErrorKey("contractual_start_date");
                        }
                      }
                    },
                    field: {
                      clearable: true,
                      onClear: () => {
                        onFieldChange("contractual_start_date", null);
                        onRestErrorKey("contractual_start_date");
                      }
                    },
                  }}
                  sx={{ width: "100%" }}
                  format={fieldDateFormat}
                  disabled={modeType === 'view'}
                />
              </LocalizationProvider>
            </Grid>
            {leaseDurationTypeValue && leaseDurationTypeValue !== 1 && (
              <Grid size={{ md: 4, xs: 12 }} mt={-0.5}>
                <TextField
                  required
                  type="text"
                  inputMode="decimal"
                  label="Lease Duration"
                  variant="outlined"
                  size="small"
                  sx={{ marginTop: "4px" }}
                  fullWidth
                  value={data?.lease_duration || ""}
                  onChange={(e) => { onFieldChange("lease_duration", e.target.value) }}
                  onFocus={() => onRestErrorKey("lease_duration")}
                  slotProps={{
                    inputLabel: { shrink: true },
                    htmlInput: { maxLength: 12, inputMode: "decimal" },
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          {[2, 3].includes(leaseDurationTypeValue) ? "FH" : "FC"}
                        </InputAdornment>
                      ),
                    }
                  }}
                  error={Boolean(error?.lease_duration)}
                  helperText={data?.lease_duration?.length > 12 ? "Maximum 10 characters allowed" : error?.lease_duration}
                />
              </Grid>
            )}
            {/* {[3, 5].includes(leaseDurationTypeValue) && (
              <Grid size={{ md: 4, xs: 12 }} mt={0.5}>
                <TextField
                  // required
                  id="time_between_interval"
                  label="Interval"
                  variant="outlined"
                  size="small"
                  margin="normal"
                  value={data.time_between_interval || ""}
                  onChange={(e) => { onFieldChange("time_between_interval", e.target.value) }}
                  onFocus={() => onRestErrorKey("time_between_interval")}
                  slotProps={{
                    inputLabel: { shrink: true },
                    htmlInput: { maxLength: 12, inputMode: "decimal" }
                  }}
                  fullWidth
                  // error={Boolean(error.time_between_interval)}
                  // helperText={error.time_between_interval}
                />
              </Grid>
            )} */}
            <Grid size={{ md: 4, xs: 12 }}>
              <TextField
                id="rental_account_number"
                label="Rental Account Number"
                variant="outlined"
                size="small"
                margin="normal"
                value={data?.rental_account_number || ""}
                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("rental_account_number", e.target.value.trimStart()) : e.preventDefault() }}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                fullWidth
              />
            </Grid>
            <Grid size={{ md: 4, xs: 12 }}>
              <TextField
                id="mr_account_number"
                label="MR Account Number"
                variant="outlined"
                size="small"
                margin="normal"
                value={data.mr_account_number || ""}
                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("mr_account_number", e.target.value.trimStart()) : e.preventDefault() }}
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 50 } }}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField
                id='planned_utilization_fh'
                label={
                  <span>
                    Planned Utilization(FH)
                    <Tooltip placement='right' title={<span>To calculate lease expected End Date </span>} arrow>
                      <InfoIcon fontSize='small' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'medium' }} />
                    </Tooltip>
                  </span>
                }
                required={leaseDurationTypeValue === 3}
                value={modeType === 'view' && data?.planned_utilization_fh ? numberWithCommas(data?.planned_utilization_fh) : (data?.planned_utilization_fh ? data?.planned_utilization_fh : "")}
                // onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange("planned_utilization_fh", e.target.value.trimStart()) : e.preventDefault(); }}
                onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? (() => { const value = e.target.value.trimStart(); onFieldChange("planned_utilization_fh", value); setError((prev) => ({ ...prev, planned_utilization_fh: value && Number(value) <= 0 ? "Planned Utilization(FH) should be greater than 0" : "", })); })() : null }
                onFocus={() => onRestErrorKey("planned_utilization_fh")}
                variant='outlined'
                size='small'
                margin='normal'
                fullWidth
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 10 } }}
                error={Boolean(error?.planned_utilization_fh)}
                helperText={error?.planned_utilization_fh}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <TextField
                id='planned_utilization_fc'
                required={leaseDurationTypeValue === 5}
                label={
                  <span>
                    Planned Utilization(FC)
                    <Tooltip placement='right' title={<span>To calculate lease expected End Date </span>} arrow>
                      <InfoIcon fontSize='small' color='primary' style={{ verticalAlign:'middle', marginLeft: '2px', fontSize: 'medium' }} />
                    </Tooltip>
                  </span>
                }
                value={modeType === 'view' && data?.planned_utilization_fc ? formatCycles(data?.planned_utilization_fc) : (data?.planned_utilization_fc ? data?.planned_utilization_fc : "")}
                // onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange("planned_utilization_fc", e.target.value) : e.preventDefault(); }}
                onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? (() => { const value = e.target.value.trimStart(); onFieldChange("planned_utilization_fc", value); setError((prev) => ({ ...prev, planned_utilization_fc: value && Number(value) <= 0 ? "Planned Utilization(FC) should be greater than 0" : "", })); })() : null }
                onFocus={() => onRestErrorKey("planned_utilization_fc")}
                variant='outlined'
                size='small'
                margin='normal'
                fullWidth
                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 10 } }}
                error={Boolean(error?.planned_utilization_fc)}
                helperText={error?.planned_utilization_fc}
              />
            </Grid>
            <Grid size={{ md: 12, xs: 12 }}>
              <FormGroup className='disabled-checkbox-wrapper'>
                <Box className="check-item-div">
                  <Checkbox sx={{ paddingLeft: 0 }} disableRipple size='small' color="primary" checked={data?.is_reserve_rate === 1 ? true : false} onChange={(e) => onFieldChange("is_reserve_rate", e.target.checked ? 1 : 0)} />
                  <Typography className="check-item-span" fontSize='14px'>Reserve Rate Not Applicable</Typography>
                </Box>
              </FormGroup>
            </Grid>
            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }} >
                {data?.id && data?.attachments?.length ?
                  <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditLeases?.data?.attachments?.length})Attachment(s)</Button> : null
                }
                <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary' endIcon={isDropDownLoading?.storage ? <ButtonLoader size={15}/>:null}>{`Available Space : ${isDropDownLoading?.storage ?"":formatBytes(data?.id?storageDetails?.remaining_storage:totalStorage)}`}</Button>
              </Box>
              {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={data?.id?storageDetails?.remaining_storage:totalStorage} />}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} disabled={isLoading}>Cancel</Button>
          <Button
            disabled={isLoading || addEditLeases.mode === "view"}
            variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditLease() }}>  {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}
          </Button>
        </DialogActions>
      </Dialog>
    </>

  )
}
export default LeaseCRU;
